import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { Field, reduxForm } from 'redux-form';
import renderInput from '../../../components/Fields/Input/Input';
import AvatarUploadContainer from '../../Fields/AvatarUpload/AvatarUploadContainer';
import LoaderButton from '../../../components/LoaderButton/LoaderButton';
import { compose } from 'redux';
import withScopedTranslations from '../../../withScopedTranslations/withScopedTranslations';
import './SettingsForm.scss';

const checkError = (value) => {
  const whiteSpaces = /^\s+$/;
  const isEmpty = '';
  return whiteSpaces.test(value) || value === isEmpty;
};

const validate = (values) => {
  const errors = {};
  const defaultErrorMessage = 'required';
  
  if (checkError(get(values, 'first_name'))) {
    errors.first_name = defaultErrorMessage;
  }
  if (checkError(get(values, 'last_name'))) {
    errors.last_name = defaultErrorMessage;
  }
  if (checkError(get(values, 'nickname'))) {
    errors.nickname = defaultErrorMessage;
  }
  if (checkError(get(values, 'phone'))) {
    errors.phone = defaultErrorMessage;
  }
  if (checkError(get(values, 'company_name'))) {
    errors.company_name = defaultErrorMessage;
  }
  if (checkError(get(values, 'ftin'))) {
    errors.ftin = defaultErrorMessage;
  }
  if (checkError(get(values, 'street'))) {
    errors.street = defaultErrorMessage;
  }
  if (checkError(get(values, 'place'))) {
    errors.place = defaultErrorMessage;
  }
  if (checkError(get(values, 'zip_code'))) {
    errors.zip_code = defaultErrorMessage;
  }
  if (checkError(get(values, 'vin'))) {
    errors.vin = defaultErrorMessage;
  }
    return errors;
};

const SettingsForm = (props) => {
  const { t, handleSubmit, pristine, valid, submitting, userData, } = props;
  const nickname = get(userData, 'nickname');
  const acceptedAvatarTypes = ['image/jpg', 'image/jpeg', 'image/png', 'image/bmp', 'image/gif'];
  const maxAvatarSize = 8388608;
  // 8Mb
  const isSubmitDisabled = pristine || (!pristine && !valid);
  return (
    <div className="row">
      <form className="settings-form" onSubmit={handleSubmit}>
        <div className="col-md-11 settings__area">
          <h1 className="settings__title">{nickname}</h1>
          <div className="row">
            <div className="col-md-9 inputs">
              <div className="row">
                <div className="col-md-6">
                  <Field name="first_name" hideMessages label={t('name')} component={renderInput} type="text" />
                </div>
                <div className="col-md-6">
                  <Field name="last_name" hideMessages label={t('surname')} component={renderInput} type="text" />
                </div>
                <div className="col-md-6">
                  <Field name="nickname" hideMessages label={t('display_name')} component={renderInput} type="text" />
                </div>
                <div className="col-md-6">
                  <Field name="phone" hideMessages label={t('telephone')} component={renderInput} type="text" />
                </div>
                <div className="col-md-6" />
                <div className="col-md-6">
                  <Field name="second_phone" hideMessages label={t('telephone_optional')} component={renderInput} type="text" />
                </div>
                <div className="col-md-12">
                  <h2 className="setting__subtitle">{t('company')}</h2>
                </div>
                <div className="col-md-6">
                  <Field name="company_name" hideMessages label={t('company_name')} component={renderInput} type="text" />
                  <Field name="ftin" hideMessages label={t('tax')} component={renderInput} type="text" />
                </div>
                <div className="col-md-6">
                  <Field name="street" hideMessages label={t('street')} component={renderInput} type="text" />
                  <Field name="place" label={t('place')} component={renderInput} type="text" />
                  <Field name="zip_code" label={t('zip_code')} component={renderInput} type="text" />
                </div>
                <div className="col-md-12 submit-area">
                  <LoaderButton
                    isLoading={submitting}
                    disabled={isSubmitDisabled}
                    label={t('save')}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-3 avatar-area">
              <Field
                name="avatar"
                component={AvatarUploadContainer}
                acceptedTypes={acceptedAvatarTypes}
                maxSize={maxAvatarSize}
              />
            </div>
          </div>
        </div>
      </form>
      <style jsx="true">{`
        .avatar-area {
          padding-left: 0;
        }
        .settings__area {
          padding-left: 15px;
          padding-top: 30px;
          border-left: 1px solid #e5e3e8;
          padding-bottom: 30px;
        }
        .settings__title {
          margin-bottom: 35px;
          font-size: 20px;
          font-weight: 900;
          color: #6c6473;
          margin-left: 15px;
        }
        .settings__area input {
          max-width: 320px;
        }
        .setting__subtitle {
          margin-bottom: 25px;
          margin-top: 20px;
          font-weight: 400;
          font-size: 20px;
          margin-left: 15px;
        }
        .inputs {
          padding-left: 0;
        }
        .submit-area {
          margin-left: 15px;
        }
      `}</style>
    </div>
  );
};

SettingsForm.propTypes = {
  valid: PropTypes.bool.isRequired,
  pristine: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  userData: PropTypes.shape({
    company_name: PropTypes.string,
    first_name: PropTypes.string,
    ftin: PropTypes.string,
    last_name: PropTypes.string,
    nickname: PropTypes.string,
    phone: PropTypes.string,
    place: PropTypes.string,
    second_phone: PropTypes.string,
    street: PropTypes.string,
    zip_code: PropTypes.string,
  }).isRequired,
};

export default compose(
  reduxForm({ form: 'settingsForm', validate, enableReinitialize: true, }),
  withScopedTranslations('dealers_settings')
)(SettingsForm);
